import money from './money';
import resize from './resize';
import dragDialog from './dragDialog';
import waterMarker from './waterMarker';
import highlightDirective from './highlight'

export default {
  install(Vue) {
    Vue.directive('money', money);
    // Vue.directive('resize', resize);
    Vue.directive('dragDialog', dragDialog);
    Vue.directive('waterMarker', waterMarker)
    Vue.directive('highlight', highlightDirective);
  }
}
